import { styled } from '@mui/material/styles';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, { accordionSummaryClasses } from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { colors } from 'theme/colors';

interface AccordionContainerProps {
  maxVisibleItems?: number;
}

export const AccordionContainer = styled('div')<AccordionContainerProps>(
  ({ maxVisibleItems }) => ({
    ...(maxVisibleItems && {
      maxHeight: `${maxVisibleItems * 49.3}px`,
      overflowY: 'auto',
    }),
  }),
);

export const StyledAccordion = styled(MuiAccordion)({
  border: `1px solid ${colors.primary50}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: 0,
  },
  margin: 0,
});

export const StyledAccordionSummary = styled(MuiAccordionSummary)({
  backgroundColor: colors.primary15,
  flexDirection: 'row-reverse',
  minHeight: '48px !important',
  height: '48px',
  padding: '8px',
  margin: 0,
  [`& .${accordionSummaryClasses.content}`]: {
    marginLeft: 1,
    margin: `0 0 0 8px`,
  },
  '.icon-minus, .icon-plus': {
    border: `2px solid ${colors.primary900}`,
    width: '15px',
    height: '15px',
  },
  [`& .${accordionSummaryClasses.expandIconWrapper}`]: {
    position: 'relative',

    '.icon-minus': {
      display: 'none',
    },

    '.icon-plus': {
      display: 'flex',
    },
  },
  [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]: {
    '.icon-minus': {
      display: 'flex',
    },

    '.icon-plus': {
      display: 'none',
    },
  },
  '&.Mui-expanded': {
    minHeight: '48px !important',
    height: '48px',
    backgroundColor: colors.white,
  },
});

export const StyledAccordionDetails = styled(MuiAccordionDetails)({
  padding: '4px 12px 16px 36px',
});
